// extracted by mini-css-extract-plugin
module.exports = {"centered":"Centered_centered__maqEa","stretchHeight":"Centered_stretchHeight__27tzN"};